import { render } from "./ReturnPoilcy.vue?vue&type=template&id=c37875b8&scoped=true"
const script = {}

import "./ReturnPoilcy.vue?vue&type=style&index=0&id=c37875b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37875b8"]])

export default __exports__